export default {
    attribute:{
        cptTableData:[
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"},
        ],
        defaultValueType: null,
        defaultValue: '',
        multiple:false,
        label:'选项：', 
        labelBoolean:true,
        labelAlign:'right',
        labelWidth:100,
        placeholder:'请选择',
        size:'medium',
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor:'#00000000',
        textColor:'#ffffff',
        textPlaceholderColor: '#333',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize:1,
        borderColor:'#333333',
        borderRadius:0,
        lineType:'solid',
        required:false,
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        showArrow:true,
        timeIcon:true,
        popupVisible:true,
        filterable:true,
        noQuery:false,
        optionBg: '#20263b',
        optionColor: '#fff',
        optionFontSize: 12,
        optionSelectedBg: 'hsla(0,0%,100%,.05)',
        optionSelectedColor: '#2c60db',
        conciseMode: false,
        conciseMode_image: '/imgPool/202408/fdd4176f23234e3e849c3972ae4dda51.png',
        conciseMode_position: 'bottom'
    },
    interaction:{multi:true,eventText:'切换选项时'},
    cptDataForm:{
        dataText: '{"value":"op1","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
        apiUrl:'/select', sql:'select id from test limit 1',
        dataSource: 1, pollTime: -1,
        isCache: false,
    }
}